import { render } from "./askAQuestionBlock.vue?vue&type=template&id=762b9ab3&scoped=true&ts=true"
import script from "./askAQuestionBlock.vue?vue&type=script&lang=ts"
export * from "./askAQuestionBlock.vue?vue&type=script&lang=ts"

import "./askAQuestionBlock.vue?vue&type=style&index=0&id=762b9ab3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762b9ab3"]])

export default __exports__